export default __webpack_public_path__ + "static/media/searchICon.752f09c7.svg";